import { render } from "./service.vue?vue&type=template&id=270dabb5&scoped=true&ts=true"
import script from "./service.vue?vue&type=script&lang=ts"
export * from "./service.vue?vue&type=script&lang=ts"

import "./service.vue?vue&type=style&index=0&id=270dabb5&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270dabb5"]])

export default __exports__